"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMarketCN = void 0;
var _environment = require("@ori/environment");
var _constants = require("../constants");
const useIsMarketCN = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  return tenant === _constants.CN_MARKET;
};
exports.useIsMarketCN = useIsMarketCN;